import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carApplications/all/history/list',
    method: 'post',
    data,
  })
}
export async function getDetail(params) {
  return request({
    url: '/carApplications/history/detail',
    method: 'get',
    params,
  })
}
export async function labelVehicle(data) {
  return request({
    url: '/label/vehicle/label',
    method: 'post',
    data,
  })
}
export async function remarkVehicle(data) {
  return request({
    url: '/label/vehicle/queryRemark',
    method: 'post',
    data,
  })
}
export async function returnVehicle(data) {
  return request({
    url: '/carApplications/return',
    method: 'post',
    data,
  })
}
export async function returnSubmit(data) {
  return request({
    url: '/carApplications/returnSubmit',
    method: 'post',
    data,
  })
}